// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e35ca4ec","977":"c99aa24f"}[chunkId] + ".chunk.js";
};